<import from="../attribute-window/attribute-window"></import>

<attribute-window first-level.bind="true"> </attribute-window>